export const configurationsReplace = {
  olivetti: [
    {
      replacements: {
        xNode: 'EasyNode',
        xSense: 'EasySense',
        xTrap: 'EasyTrap',
        xWater: 'EasyWater',
        xCam: 'EasyCam',
        xRad: 'EasyRad',
        xLeaf: 'EasyLeaf',
      },
      path: 'xsense.type',
    },
  ],
};
